// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Deal details page: mobile first, everything scoped under .DealDetails */

.DealDetails {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-4);
  min-width: 0;
  overflow-wrap: anywhere;
}

/* ── Header: identity + actions (stacked on phones) ─────────── */
.DealDetails .deal-details__header .ant-card-body {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-4);
  padding: var(--ds-space-4);
}

.DealDetails .deal-details__header .ant-card-body::before,
.DealDetails .deal-details__header .ant-card-body::after {
  display: none;
}

.DealDetails .deal-details__identity {
  display: flex;
  align-items: center;
  gap: var(--ds-space-4);
  min-width: 0;
}

.DealDetails .deal-details__avatar {
  flex: 0 0 auto;
}

.DealDetails .deal-details__identity-text {
  min-width: 0;
}

.DealDetails .deal-details__identity-text h2 {
  margin-bottom: 0;
  font-size: 20px;
  font-weight: 700;
  color: var(--ds-text);
}

.DealDetails .deal-details__identity-text p {
  margin: var(--ds-space-1) 0 0;
  color: var(--ds-text-2);
}

.DealDetails .deal-details__header-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--ds-space-2);
}

.DealDetails .deal-details__header-actions > * {
  flex: 1 1 0;
  min-height: 40px;
}

/* Won/Lost pill: color comes from the antd token set inline as --deal-status-color */
.DealDetails .deal-details__status {
  min-width: 110px;
}

.DealDetails .deal-details__status .ant-select-selector {
  background: var(--deal-status-color, var(--ds-brand));
  border-radius: var(--ds-radius-md);
}

.DealDetails .deal-details__status .ant-select-selection-item,
.DealDetails .deal-details__status .ant-select-arrow {
  color: var(--deal-status-text, var(--ds-surface));
  font-weight: 600;
}

/* ── Body ───────────────────────────────────────────────────── */
.DealDetails .dealInfo .ant-card-body {
  display: flex;
  flex-direction: column;
  row-gap: var(--ds-space-5);
}

.DealDetails .dealInfo h2 {
  margin-bottom: 0;
  font-size: 18px;
  font-weight: 700;
}

.DealDetails .deal-details__facts {
  display: grid;
  gap: var(--ds-space-2);
  margin: 0;
}

.DealDetails .deal-details__facts > div {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: var(--ds-space-1) var(--ds-space-3);
  padding-block-end: var(--ds-space-2);
  border-bottom: 1px solid var(--ds-border-soft);
}

.DealDetails .deal-details__facts dt {
  font-weight: 600;
  color: var(--ds-text-2);
}

.DealDetails .deal-details__facts dd {
  margin: 0;
  text-align: end;
  color: var(--ds-text);
}

.DealDetails .deal-details__tags {
  display: flex;
  flex-wrap: wrap;
  gap: var(--ds-space-2);
}

.DealDetails .deal-details__steps {
  min-width: 0;
}

.DealDetails .activity-section {
  margin-top: var(--ds-space-2);
}

/* ── Tablet and up: header on one row ───────────────────────── */
@media (min-width: 768px) {
  .DealDetails .deal-details__header .ant-card-body {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: var(--ds-space-6);
  }

  .DealDetails .deal-details__identity-text h2 {
    font-size: 28px;
  }

  .DealDetails .deal-details__header-actions {
    flex-wrap: nowrap;
    justify-content: flex-end;
  }

  .DealDetails .deal-details__header-actions > * {
    flex: 0 0 auto;
  }

  .DealDetails .activity-section {
    margin-top: var(--ds-space-5);
  }
}
`, "",{"version":3,"sources":["webpack://./src/serviceProvider/components/deals/DealDetails/DealDetails.css"],"names":[],"mappings":"AAAA,0EAA0E;;AAE1E;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;AACzB;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,qFAAqF;AACrF;EACE,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,kCAAkC;AACpC;;AAEA;;EAEE,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,wCAAwC;EACxC,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,kEAAkE;AAClE;EACE;IACE,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,6BAA6B;EAC/B;AACF","sourcesContent":["/* Deal details page: mobile first, everything scoped under .DealDetails */\n\n.DealDetails {\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-4);\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n/* ── Header: identity + actions (stacked on phones) ─────────── */\n.DealDetails .deal-details__header .ant-card-body {\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-4);\n  padding: var(--ds-space-4);\n}\n\n.DealDetails .deal-details__header .ant-card-body::before,\n.DealDetails .deal-details__header .ant-card-body::after {\n  display: none;\n}\n\n.DealDetails .deal-details__identity {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-4);\n  min-width: 0;\n}\n\n.DealDetails .deal-details__avatar {\n  flex: 0 0 auto;\n}\n\n.DealDetails .deal-details__identity-text {\n  min-width: 0;\n}\n\n.DealDetails .deal-details__identity-text h2 {\n  margin-bottom: 0;\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--ds-text);\n}\n\n.DealDetails .deal-details__identity-text p {\n  margin: var(--ds-space-1) 0 0;\n  color: var(--ds-text-2);\n}\n\n.DealDetails .deal-details__header-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: var(--ds-space-2);\n}\n\n.DealDetails .deal-details__header-actions > * {\n  flex: 1 1 0;\n  min-height: 40px;\n}\n\n/* Won/Lost pill: color comes from the antd token set inline as --deal-status-color */\n.DealDetails .deal-details__status {\n  min-width: 110px;\n}\n\n.DealDetails .deal-details__status .ant-select-selector {\n  background: var(--deal-status-color, var(--ds-brand));\n  border-radius: var(--ds-radius-md);\n}\n\n.DealDetails .deal-details__status .ant-select-selection-item,\n.DealDetails .deal-details__status .ant-select-arrow {\n  color: var(--deal-status-text, var(--ds-surface));\n  font-weight: 600;\n}\n\n/* ── Body ───────────────────────────────────────────────────── */\n.DealDetails .dealInfo .ant-card-body {\n  display: flex;\n  flex-direction: column;\n  row-gap: var(--ds-space-5);\n}\n\n.DealDetails .dealInfo h2 {\n  margin-bottom: 0;\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.DealDetails .deal-details__facts {\n  display: grid;\n  gap: var(--ds-space-2);\n  margin: 0;\n}\n\n.DealDetails .deal-details__facts > div {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: var(--ds-space-1) var(--ds-space-3);\n  padding-block-end: var(--ds-space-2);\n  border-bottom: 1px solid var(--ds-border-soft);\n}\n\n.DealDetails .deal-details__facts dt {\n  font-weight: 600;\n  color: var(--ds-text-2);\n}\n\n.DealDetails .deal-details__facts dd {\n  margin: 0;\n  text-align: end;\n  color: var(--ds-text);\n}\n\n.DealDetails .deal-details__tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--ds-space-2);\n}\n\n.DealDetails .deal-details__steps {\n  min-width: 0;\n}\n\n.DealDetails .activity-section {\n  margin-top: var(--ds-space-2);\n}\n\n/* ── Tablet and up: header on one row ───────────────────────── */\n@media (min-width: 768px) {\n  .DealDetails .deal-details__header .ant-card-body {\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    padding: var(--ds-space-6);\n  }\n\n  .DealDetails .deal-details__identity-text h2 {\n    font-size: 28px;\n  }\n\n  .DealDetails .deal-details__header-actions {\n    flex-wrap: nowrap;\n    justify-content: flex-end;\n  }\n\n  .DealDetails .deal-details__header-actions > * {\n    flex: 0 0 auto;\n  }\n\n  .DealDetails .activity-section {\n    margin-top: var(--ds-space-5);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
